import { render, staticRenderFns } from "./AgingMerchant.vue?vue&type=template&id=5f3f4626&"
import script from "./AgingMerchant.vue?vue&type=script&lang=js&"
export * from "./AgingMerchant.vue?vue&type=script&lang=js&"
import style0 from "./AgingMerchant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports